export function clamp (value, min, max) {
	return Math.max(min, Math.min(max, value))
}

export function rand (min, max) {
	min = Math.ceil(min)
	max = Math.floor(max)
	return Math.floor(Math.random() * (max - min + 1)) + min
}